export default "__VITE_ASSET__Cpp8FZ5B__"